// extracted by mini-css-extract-plugin
module.exports = {"vLinkColor":"#1c7cf4","vGray11":"#5e616b","text":"SmsTimer_text__1FAdo","timer":"SmsTimer_timer__3Ik44","action":"SmsTimer_action__2TZPK","actionLink":"SmsTimer_actionLink__lu-fC"};